module.exports = __webpack_public_path__ + "img/page-bg.f77f6744.webp";